import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from 'reactstrap';

interface Props {
    colSpan: number;
    isLoading: boolean;
    error?: string | null;
    entityName: string;
}

const TableEmptyState = ({ colSpan, isLoading, error, entityName }: Props) => {
    if (isLoading) {
        return (
            <tr>
                <td colSpan={colSpan} className="text-center py-4" role="status" aria-live="polite">
                    <Spinner size="sm" className="me-2" aria-hidden="true" />
                    Loading {entityName}...
                </td>
            </tr>
        );
    }

    if (error) {
        return (
            <tr>
                <td colSpan={colSpan} className="text-center py-4 text-danger" role="alert">
                    <FontAwesomeIcon icon="exclamation-circle" className="me-2" aria-hidden="true" />
                    Failed to load {entityName}
                </td>
            </tr>
        );
    }

    return (
        <tr>
            <td colSpan={colSpan} className="text-center py-4 text-muted" role="status">
                <FontAwesomeIcon icon="inbox" className="me-2" aria-hidden="true" />
                No {entityName} to display
            </td>
        </tr>
    );
};

export default TableEmptyState;
